import Vue from 'vue'
import Vuex, {Store} from 'vuex'
import VuexPersistence from 'vuex-persist'
import localForage from 'localforage'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    spToken: "",
    graphToken: "",
    msalInstance: "",
    input: {},
    outputBlob: {}
  },
  mutations: {
    updateSpToken(state, payload) {
      state.spToken = payload
    },
    updateGraphToken(state, payload) {
      state.graphToken = payload
    },
    updateMsalInstance(state, payload) {
      state.msalInstance = payload
    },
    updateOutputBlob(state, payload) {
      state.outputBlob = payload
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [new VuexPersistence({
    storage: localForage,
    asyncStorage: true,
    reducer: state => ({outputBlob: (state as any).outputBlob}),
  }).plugin]
})
